module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  })]), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5c22768"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About/StaticPages.vue
// module id = 836
// module chunks = 1